import { render, staticRenderFns } from "./SppucDataTable.vue?vue&type=template&id=a1f9ea4a"
import script from "./SppucDataTable.vue?vue&type=script&lang=js"
export * from "./SppucDataTable.vue?vue&type=script&lang=js"
import style0 from "./SppucDataTable.vue?vue&type=style&index=0&id=a1f9ea4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports